import { LegendRendererProps } from '@mui/x-charts';
import { TFunction } from 'i18next';

export const getChartLegendConfig = (
  showLegend: boolean
): Partial<LegendRendererProps> => {
  return {
    hidden: !showLegend,
    direction: 'column',
    position: {
      vertical: 'top',
      horizontal: 'right',
    },
    padding: {
      top: 40,
    },
    itemMarkWidth: 10,
    itemMarkHeight: 10,
    markGap: 5,
    itemGap: 5,
    labelStyle: {
      fontSize: 12,
    },
  };
};

export const getChartNoDataOverlay = (t: TFunction) => {
  return { message: t('common:customDashboard.noData') };
};

export const BENCHMARK_DATA_PREFIX = 'benchmarkData';
export const BOTTOM_AXIS_ID = 'bottomAxisId';
export const LEFT_AXIS_ID = 'leftAxisId';
export const RIGHT_AXIS_ID = 'rightAxisId';
export const TOP_AXIS_ID = 'topAxisId';
